import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo8 } from "../../../routes/Module8";
import { modulo9 } from "../../../routes/Module9";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo8/presidente.png";
import Imagen2 from "../../../images/modulo8/congresista.png";
import Imagen3 from "../../../images/modulo8/alcaldesa.png";
import Imagen4 from "../../../images/modulo8/ministra.png";
import Imagen5 from "../../../images/modulo8/presidenta.png";
import Imagen6 from "../../../images/modulo8/gobernador.png";
import Imagen7 from "../../../images/modulo8/alcalde.png";
import Imagen8 from "../../../images/modulo8/gobernadora.png";
import Imagen9 from "../../../images/modulo8/congresistam.png";
import Imagen10 from "../../../images/modulo8/ministro.png";
import Imagen11 from "../../../images/modulo8/comisario.png";
import Imagen12 from "../../../images/modulo8/fiscal.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo8/Actividad 8.mp3";

const Actividad9 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "1" },
    ans2: { value: "", valid: "", correctValue: "1" },
    ans3: { value: "", valid: "", correctValue: "1" },
    ans4: { value: "", valid: "", correctValue: "0" },
    ans5: { value: "", valid: "", correctValue: "1" },
    ans6: { value: "", valid: "", correctValue: "1" },
    ans7: { value: "", valid: "", correctValue: "1" },
    ans8: { value: "", valid: "", correctValue: "1" },
    ans9: { value: "", valid: "", correctValue: "1" },
    ans10: { value: "", valid: "", correctValue: "0" },
    ans11: { value: "", valid: "", correctValue: "0" },
    ans12: { value: "", valid: "", correctValue: "0" },
  });
  const infoUnidad = modulo8.content[0];
  const infoAct = modulo8.content[0].activities[7];
  const crumbs = [
    {
      title: modulo8.title,
      url: "/" + modulo8.url,
    },
    {
      title:
        modulo8.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo8.content[0].activities[6].name}`,
    linkPrev: `${modulo8.url}/${modulo8.content[0].path}/${modulo8.content[0].activities[6].path}`,
  };
  const metadata = {
    color: modulo8.color,
    title: `${modulo8.title} - ${infoAct.name}`,
    name: modulo8.title,
  };
  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo8.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="mb-5">
        <li>
          ¿A quiénes podemos elegir con el voto en el Perú? Márcalos con un
          check.
        </li>
        <li>
          Puedes descargar las imágenes en las que pusiste check para
          colorearlas.
        </li>
      </ul>

      <div className="row">
        <div className="col-lg-4 col-6">
          <img src={Imagen1} alt="Candidatos" className="img-fluid" />
          <Card>
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md me-2 " + answers.ans1.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans1.value === "1"}
                onChange={(event) => handleAnswers(event, "ans1")}
              />
              <div>Presidente</div>
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-6">
          <img src={Imagen2} alt="Candidatos" className="img-fluid" />
          <Card>
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md me-2 " + answers.ans2.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans2.value === "1"}
                onChange={(event) => handleAnswers(event, "ans2")}
              />
              <div>Congresista</div>
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-6">
          <img src={Imagen3} alt="Candidatos" className="img-fluid" />
          <Card>
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md me-2 " + answers.ans3.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans3.value === "1"}
                onChange={(event) => handleAnswers(event, "ans3")}
              />
              <div>Alcaldesa</div>
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-6">
          <img src={Imagen4} alt="Candidatos" className="img-fluid" />
          <Card>
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md me-2 " + answers.ans4.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans4.value === "1"}
                onChange={(event) => handleAnswers(event, "ans4")}
              />
              <div>Ministra</div>
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-6">
          <img src={Imagen5} alt="Candidatos" className="img-fluid" />
          <Card>
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md me-2 " + answers.ans5.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans5.value === "1"}
                onChange={(event) => handleAnswers(event, "ans5")}
              />
              <div>Presidenta</div>
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-6">
          <img src={Imagen6} alt="Candidatos" className="img-fluid" />
          <Card>
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md me-2 " + answers.ans6.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans6.value === "1"}
                onChange={(event) => handleAnswers(event, "ans6")}
              />
              <div>Gobernador regional</div>
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-6">
          <img src={Imagen7} alt="Candidatos" className="img-fluid" />
          <Card>
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md me-2 " + answers.ans7.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans7.value === "1"}
                onChange={(event) => handleAnswers(event, "ans7")}
              />
              <div>Alcalde</div>
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-6">
          <img src={Imagen8} alt="Candidatos" className="img-fluid" />
          <Card>
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md me-2 " + answers.ans8.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans8.value === "1"}
                onChange={(event) => handleAnswers(event, "ans8")}
              />
              <div>Gobernadora regional</div>
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-6">
          <img src={Imagen9} alt="Candidatos" className="img-fluid" />
          <Card>
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md me-2 " + answers.ans9.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans9.value === "1"}
                onChange={(event) => handleAnswers(event, "ans9")}
              />
              <div>Congresista</div>
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-6">
          <img src={Imagen10} alt="Candidatos" className="img-fluid" />
          <Card>
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md me-2 " + answers.ans10.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans10.value === "1"}
                onChange={(event) => handleAnswers(event, "ans10")}
              />
              <div>Ministro</div>
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-6">
          <img src={Imagen11} alt="Candidatos" className="img-fluid" />
          <Card>
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md me-2 " + answers.ans11.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans11.value === "1"}
                onChange={(event) => handleAnswers(event, "ans11")}
              />
              <div>Comisario</div>
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-6">
          <img src={Imagen12} alt="Candidatos" className="img-fluid" />
          <Card>
            <div className="d-flex align-items-center">
              <input
                className={
                  "form-check-input mb-1 form-md me-2 " + answers.ans12.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans12.value === "1"}
                onChange={(event) => handleAnswers(event, "ans12")}
              />
              <div>Fiscal</div>
            </div>
          </Card>
        </div>
      </div>
      <div className="d-flex w-100 justify-content-end my-4">
        <button
          className={`btn btn-${modulo8.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul className="mb-0">
            <li>
              Cuando tengas 18 años y puedas votar, ¿cómo te gustaría que fuera
              el presidente o la presidenta del Perú?
            </li>
            <li>Escribe sus principales características.</li>
          </ul>
          <textarea className="form-control" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen los personajes y lean sus cargos. Ayude
          a identificar a quiénes elegimos y a quiénes no (no elegimos a los
          ministros, los comisarios, los fiscales).
        </p>
        
      </GuiaDocente>
      <div className="unit-options my-5 d-flex flex-column">
        <p>Ir al siguiente módulo:</p>
        <a href={"/" + modulo9.url}>
          <button className={`btn btn-${modulo8.color} me-2`}>
            {modulo9.title + " >"}
          </button>
        </a>
      </div>
    </LayoutActividad>
  );
};

export default Actividad9;
